import { useMemo } from 'react';

import { isDefined, isNotEmpty, sort } from '@hsp/utilities';

import { isMultiData } from '@u/is-multi-data';

import { IClient } from 'types/api/client';
import { DataValue } from 'types/components/common';

export const useAddMissingClients = (clients: IClient[], selected: DataValue<IClient> = []) => {
  return useMemo(() => {
    let initialData = [...clients];
    const ids = new Set(initialData.map((client) => client?.id));
    let selectedClients: IClient[] = [];

    if (isDefined(selected) && isNotEmpty(selected)) {
      selectedClients = [...(isMultiData(selected) ? selected : [selected])] as IClient[];
    }

    initialData = [...initialData, ...selectedClients.filter((client) => !ids.has(client.id))];

    sort(initialData, { direction: 'asc', field: 'name' });

    return initialData;
  }, [clients, selected]);
};
